import React, { useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const IrbmStatusFilter = ({ onChange }) => {
  const [value, setValue] = useState(null);
  const options = [
    { value: 'Submitted', label: 'Submitted' },
    { value: 'Valid', label: 'Approved' },
    { value: 'Cancelled', label: 'Cancelled' },
    { value: 'Invalid', label: 'Rejected' },
  ];

  const handleChange = (_, selectedOption) => {
    setValue(selectedOption);
    onChange(selectedOption?.value || null);
  };

  return (
    <Autocomplete
      value={value}
      options={options}
      getOptionLabel={(option) => option.label || ''}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={handleChange}
      renderInput={(params) => (
        <TextField {...params} label="Status" variant="outlined" size="small" sx={{ minWidth: 200 }} />
      )}
      clearOnBlur={false}
    />
  );
};

export default IrbmStatusFilter;
